import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { ILead } from '@clickersphere/core/entities/ILead';
import LeadService from '@clickersphere/core/services/LeadService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const LEADS_QUERY_KEY = 'leads';

export type LeadQueryData = WithQueryStatus<ILead>;

export function useLeads() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: leads,
    isSuccess: isLeadsSuccess,
    isFetching: isLeadsFetching,
    isLoading: isLeadsLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(LEADS_QUERY_KEY),
    queryFn: async () => {
      const leads = await LeadService.getAll();

      return leads as LeadQueryData[];
    },
    select: (data) => {
      return data
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .sort((a, b) => (a.active > b.active ? -1 : 1));
    },
  });

  return {
    leads,
    isLeadsSuccess,
    isLeadsFetching,
    isLeadsLoading,
  };
}
